import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/UrbanGenerator",
    name: "UrbanGenerator",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/UrbanGenerator"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login/index"),
    redirect: { name: "Home" },
  },
  {
    path: "/userterm",
    name: "userterm",
    component: () => import("../views/Terms/register"),
    redirect: { name: "Home" },
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/Terms/privacy"),
    redirect: { name: "Home" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

/** TODO: 暂时去除登录 */
// router.beforeEach((to, from, next) => {
//   const whiteList = ["login", "userterm", "privacy"];
//   if (whiteList.includes(to.name)) {
//     next();
//   } else {
//     const token = localStorage.getItem("JWT_TOKEN");
//     if (token) {
//       next();
//     } else {
//       next({ name: "login" });
//     }
//   }
// });

export default router;
